import { render } from "./bookingLoader.vue?vue&type=template&id=ef2d6a5e&scoped=true"
import script from "./bookingLoader.vue?vue&type=script&lang=js"
export * from "./bookingLoader.vue?vue&type=script&lang=js"

import "./bookingLoader.vue?vue&type=style&index=0&id=ef2d6a5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2d6a5e"]])

export default __exports__